import React from "react";
import { getPortfolioItem } from "../../api/portfolio/PortfolioData";

import { Container } from "react-bootstrap";
import FadeUpTrigger from "../../animation/FadeUpTrigger";
import TextTrigger from "../../animation/TextTrigger";
import { faAngleRight } from "@fortawesome/free-solid-svg-icons";
import DsnGrid from "../../components/DsnGrid";
//--> Component
import HeaderHalf from "../../components/header/HeaderHalf";
import TitleCover from "../../components/heading/title-cover/TitleCover";
import ButtonProject from "../../components/button/button-project/ButtonProject";
import ButtonDefault from "../../components/button/button-default/ButtonDefault";
import BoxImageVertical from "../../components/box-image-vertical/BoxImageVertical";
import ParallaxImage from "../../components/parallax-image/ParallaxImage";
import NextProject from "../../components/next/NextProject";
import { Helmet } from 'react-helmet-async';
import ButtonPopup from "../../components/button/button-popup/ButtonPopup";

const HowDoYouChew = ({ data }) => {
  const nextData = getPortfolioItem(3);
  return (
    <React.Fragment>
      <Helmet>
        <title>Devlift - {data.title} </title>
        <link rel='canonical' href='/portolio/excel' />
        <meta name="description" content={data.description} />
      </Helmet>
      {/*Start Header Half*/}
      <HeaderHalf
        heroContent={data}
        parallax={{ yPercent: 30 }}
        overlay={data.overlay}
        href="#"
      ></HeaderHalf>
      {/*End Header Half*/}

      {/*Start Info Project*/}
      <Container className="section-margin">
        <TitleCover>The Ask</TitleCover>
        <TextTrigger duration={0.8} stagger={0.1}>
          {(ref) => (
            <h2 className="title-section" ref={ref}>
              The Ask
            </h2>
          )}
        </TextTrigger>
        <FadeUpTrigger>
          <p className="mt-20">
            For over a century Wrigley’s has dominated the world of chewing gum. To continue being a staple in many consumers’ pockets, Wrigley’s came out with the “How do you chew” campaign where eight different chewing styles were introduced.
          </p>
          <p className="mt-20">
            Devlift was engaged to build a branded contest microsite, where consumers were directed to discover their chewing style by simply selecting one of the predetermined chew styles or by taking a fun quiz to help determine the best chew style for them and to enter to win a grand prize or smaller secondary prizes. Consumers were also encouraged to share their chew styles on social media as well as to tag a friend with their chew style.
          </p>
        </FadeUpTrigger>
      </Container>
      {/*End Info Project*/}

      {/*Start Grid Project*/}
      <Container className="section-margin">
        <DsnGrid
          col={1}
          colGap={50}
          rowGap={50}
          colGapTablet={30}
          rowGapTablet={30}
        >
          <img src="/assets/img/project/excel/main-page.png" alt="" />
        </DsnGrid>
      </Container>
      {/*Start Grid Project*/}

      {/*Start Box Info With Image*/}
      <BoxImageVertical
        src="/assets/img/project/excel/banner3.png"
        className="section-margin"
      >
        <FadeUpTrigger>
          {(ref) => (
            <DsnGrid col={1} rowGap={30} rowGapTablet={20}>
              <TitleCover>The Solution</TitleCover>
              <h2 className="title-section border-line-left" ref={ref}>
                The Solution
              </h2>
              <p ref={ref}>
                The Devlift team built a custom client side digital solution with modern web technologies and multilingual support.  The front-end of the site delivered lightning fast loading times for quick exploration and seamless contest entry.  Behind the scenes, the team ensured the site had a secure backend with multiple entry detection along with a contest administration platform with a robust custom analytics system.
              </p>
              <p ref={ref}>
                To support the customer engagement metrics, Devlift incorporated big data querying solutions that offered detailed insight into consumer behaviour.  Large scale analytics and segmentation deployment further allowed for successful remarketing of campaigns.
              </p>
              {/* <div className="button-box" ref={ref}>
                            <ButtonDefault text="launch" icon={faAngleRight} href="#0"/>
                        </div> */}
            </DsnGrid>
          )}
        </FadeUpTrigger>
      </BoxImageVertical>
      {/*End  Box Info With Image*/}
      <Container className="section-margin">
        <DsnGrid
          col={1}
          colGap={50}
          rowGap={50}
          colGapTablet={30}
          rowGapTablet={30}
        >
          <img src="/assets/img/project/excel/mobile.png" alt="" />
        </DsnGrid>
      </Container>

      <div className="p-relative section-margin v-dark-head text-center">
        <ParallaxImage
          src="/assets/img/project/excel/banner2.png"
          heightMobile="50vh"
          heightTable="100vh"
          overlay={0}
        />

        <FadeUpTrigger tag={Container} className="v-middle z-index-1">
          {/* <h2>The Showroom</h2>
            <p className="m-w570 mt-20 dsn-auto">
            When the Escalators Died in Stockholm’s Subway, Reebok Was
            There to Give People a Lift.Literally
            </p> */}
          {/* <ButtonPopup className="mt-20" href="/assets/videos/hdyc.mp4" />  hide video for now  */}
        </FadeUpTrigger>
      </div>
      <NextProject heroContent={nextData} overlay={nextData.overlay} />
    </React.Fragment>
  );
};

export default HowDoYouChew;
